// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1D_p5","requiredAsterisk":"Info_requiredAsterisk__P0bn1"};